// Locale-aware formatting. Times are shown in CET (Europe/Berlin) to match the
// gateway's interpretation (see docs/DESIGN_GUIDELINES.md).

const CET = 'Europe/Berlin'

export function formatMoney(amount: string | number, currency: string, locale: string): string {
  const value = typeof amount === 'string' ? Number(amount) : amount
  if (!Number.isFinite(value)) return `${amount} ${currency}`

  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value)
  } catch {
    return `${value.toFixed(2)} ${currency}`
  }
}

export function formatDateTime(iso: string | null, locale: string): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso

  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short', timeZone: CET }).format(date)
}

export function formatDate(iso: string | null, locale: string): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso

  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeZone: CET }).format(date)
}

/** Short, copy-friendly transaction id (first segment of the UUID). */
export function shortId(id: string): string {
  return id.split('-')[0] ?? id
}

/** "completed" → "Completed", "partially_refunded" → "Partially refunded". */
export function humanize(value: string): string {
  if (!value) return ''
  const text = value.replace(/_/g, ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}
